import isNil from "lodash/isNil";
import { useQuery } from "urql";

import { GetClikGrantedCreditDetailsDocument } from "../../../../graphql/generated.ts";

interface Props {
  id: number | string | null | undefined;
}

export const useClikGrantedDetailsOfCredit = ({ id }: Props) => {
  return useQuery({
    query: GetClikGrantedCreditDetailsDocument,
    variables: { id: Number(id) },
    pause: isNil(id),
  });
};
